import { BrowserFailure } from './browser-service.interface';

export class BrowserServiceFailure implements BrowserFailure, Error {
  name: string;
  message: string;
  stack?: string | undefined;

  constructor(err: Error) {
    this.name = err.name;
    this.message = err.message;
    this.stack = err.stack;
  }
}

/*
 * Browser location permission failures
 */
export class LocationPermissionFailure extends BrowserServiceFailure {
  constructor() {
    super(new Error('Location permission'));
  }
}

export class LocationDeniedPermissionFailure extends BrowserServiceFailure {
  constructor() {
    super(new Error('User denied location permission'));
  }
}
export class LocationTimeoutFailure extends BrowserServiceFailure {
  constructor() {
    super(new Error('Location timeout'));
  }
}

export class BrowserServiceFailures {
  static insufficientLocationPermission = () => new LocationPermissionFailure();
}
